/* ==========================================================================
   MEDICORA — Two-Step Body Routine landing page

   Presentation only. The cart is Horizon's: every buy form on this page is a
   real <product-form-component>, so adding to cart, the drawer, the error
   states and the line-item properties are all the theme's own code. Nothing
   here touches the cart, and no library is loaded.
   ========================================================================== */
(function () {
  "use strict";

  var root = document.querySelector(".lp");
  if (!root || window.MedicoraLPReady) return;
  window.MedicoraLPReady = true;

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function qsa(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  /* ------------------------------------------------- hero media gallery --
     The track owns the state: the browser scrolls it (swipe, trackpad, thumb
     click) and a scroll listener reads back which slide is centred. Nothing
     here swaps an src, so each image keeps its own srcset and no slide ever
     reloads. With JavaScript off the track is still a working swipe gallery;
     only the thumbnail highlight stops following. */
  qsa("[data-lp-gallery]").forEach(function (gal) {
    var stage = gal.querySelector("[data-lp-stage]");
    var slides = qsa("[data-lp-slide]", gal);
    var thumbs = qsa("[data-lp-thumb]", gal);
    var rail = thumbs.length ? thumbs[0].parentNode : null;
    if (!stage || !rail || slides.length < 2 || thumbs.length !== slides.length) return;

    var current = 0;
    var behavior = reduce ? "auto" : "smooth";

    function keepThumbInView(thumb) {
      if (rail.scrollWidth <= rail.clientWidth + 1) return;
      var t = thumb.getBoundingClientRect();
      var r = rail.getBoundingClientRect();
      if (t.left < r.left || t.right > r.right) {
        rail.scrollTo({
          left: thumb.offsetLeft - (rail.clientWidth - thumb.offsetWidth) / 2,
          behavior: behavior
        });
      }
    }

    function mark(index) {
      current = index;
      thumbs.forEach(function (t, n) {
        t.setAttribute("aria-current", n === index ? "true" : "false");
      });
      keepThumbInView(thumbs[index]);
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener("click", function () {
        stage.scrollTo({
          left: slides[index].offsetLeft - slides[0].offsetLeft,
          behavior: behavior
        });
        mark(index);
      });
    });

    var ticking = false;
    stage.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var base = slides[0].offsetLeft;
        var centre = stage.scrollLeft + stage.clientWidth / 2;
        var nearest = 0;
        var shortest = Infinity;
        slides.forEach(function (slide, n) {
          var distance = Math.abs(
            slide.offsetLeft - base + slide.offsetWidth / 2 - centre
          );
          if (distance < shortest) { shortest = distance; nearest = n; }
        });
        if (nearest !== current) mark(nearest);
      });
    }, { passive: true });

    mark(0);
  });

  /* --------------------------------------------------------- reveal ---- */
  if (!("IntersectionObserver" in window) || reduce) {
    qsa(".lp-rv").forEach(function (n) { n.classList.add("is-in"); });
  } else {
    var rv = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-in"); rv.unobserve(e.target); }
      });
    }, { rootMargin: "0px 0px -6% 0px", threshold: 0.04 });
    qsa(".lp-rv").forEach(function (n) { rv.observe(n); });
  }

  /* ------------------------------------------------------ accordions --- */
  qsa(".lp-faq__item").forEach(function (item) {
    var btn = item.querySelector(".lp-faq__q");
    var panel = item.querySelector(".lp-faq__a");
    if (!btn || !panel) return;
    btn.addEventListener("click", function () {
      var open = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", String(!open));
      item.classList.toggle("is-open", !open);
      panel.hidden = open;
    });
  });

  /* -------------------------------------------------------- quantity --- */
  /* Each buy panel owns its own stepper. The input is the single source of
     truth; the -/+ buttons write into it and the native spinners are hidden
     in CSS so there is only one visible way to change the number. */
  qsa("[data-lp-qty]").forEach(function (wrap) {
    var input = wrap.querySelector("input");
    var down = wrap.querySelector("[data-lp-qty-down]");
    var up = wrap.querySelector("[data-lp-qty-up]");
    if (!input) return;
    var MIN = parseInt(input.getAttribute("min"), 10) || 1;
    var MAX = parseInt(input.getAttribute("max"), 10) || 99;

    function clamp(v) { return Math.max(MIN, Math.min(MAX, v)); }

    function sync(commit) {
      var raw = parseInt(input.value, 10);
      if (commit || !isNaN(raw)) input.value = clamp(isNaN(raw) ? MIN : raw);
      var v = parseInt(input.value, 10) || MIN;
      if (down) down.disabled = v <= MIN;
      if (up) up.disabled = v >= MAX;
    }
    function step(by) {
      input.value = clamp((parseInt(input.value, 10) || MIN) + by);
      sync(true);
    }
    if (up) up.addEventListener("click", function () { step(1); });
    if (down) down.addEventListener("click", function () { step(-1); });
    input.addEventListener("input", function () { sync(false); });
    input.addEventListener("blur", function () { sync(true); });
    sync(true);
  });

  /* ---------------------------------------------------------- sticky --- */
  /* Appears once the hero CTA has scrolled away, and steps aside near the
     final CTA so it never sits on top of it. Deterministic scroll maths rather
     than an IntersectionObserver: a fast flick can skip an observer's
     intermediate states, and this bar must never be caught in the wrong one. */
  var bar = document.querySelector("[data-lp-sticky]");
  if (bar) {
    var heroCta = document.querySelector("[data-lp-hero-cta]");
    var endCta = document.querySelector("[data-lp-end-cta]");
    var shown = null;
    var ticking = false;

    function apply() {
      var y = window.scrollY || window.pageYOffset || 0;
      var vh = window.innerHeight;
      var pastHero = heroCta
        ? y > heroCta.getBoundingClientRect().bottom + y - vh * 0.35
        : y > vh * 0.9;
      var atEnd = endCta
        ? endCta.getBoundingClientRect().top < vh * 0.9
        : false;
      var show = pastHero && !atEnd;
      if (show === shown) return;
      shown = show;
      bar.classList.toggle("is-in", show);
      bar.classList.toggle("is-out", !show);
      bar.setAttribute("aria-hidden", String(!show));
      qsa("a, button, input", bar).forEach(function (el) {
        if (show) el.removeAttribute("tabindex");
        else el.setAttribute("tabindex", "-1");
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; apply(); });
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    apply();
  }
})();
